import React, { Component } from 'react';
import Tree from 'react-vertical-tree'
// import {withStyles} from 'react-vertical-tree';
import Affiliator from '../../Models/Affiliator';

class MLMTree extends Component {

	constructor(props) {
		super(props);
		this.state = {
			title: null,
			data: []
		};
		var id = JSON.parse(window.localStorage.getItem('info'))
		console.log(id)
		this.getaffiliatorId(id.id)
	}
	componentDidMount() {
		window.scrollTo(0, 0)
	}
	getaffiliatorId(id) {
		Affiliator.getAffiliatorTree(id).then(res => {
			res.data.tree.map(res => 
				this.setState({ data: res })
			)
		})
	}

	render() {
		let data=[]
		data=this.state.data;
		return (
			<div>
				<Tree data={data} withStyles
					onClick={item => alert(item.id + ' ' + item.ref_link)}
				/>
			</div>
		);
	}
}

export { MLMTree };
